import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useProCount(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    supabase.rpc("get_pro_count").then(({ data }) => {
      if (typeof data === "number") setCount(data);
    });
  }, []);
  return count;
}
